import React from 'react';
import { InstagramEmbed } from 'react-social-media-embed';
import './InstagramSection.css';

const InstagramSection = () => {
  return (
    <section className="instagram-section">
      <h2>Urmărește-ne pe Instagram!</h2>
      <div className="instagram-embed-container">
        <InstagramEmbed
          url="https://www.instagram.com/gradinita_margot_oradea/"
          width={480}
        />
      </div>
    </section>
  );
};

export default InstagramSection;
